<template>
  <div>
    <div v-if="!mobile" class="d-flex mb-4">
      <div>
        <div class="d-flex align-center">
          <h2 class="text-h5 mb-2 mr-2 font-weight-regular">
            {{ title }}
          </h2>
          <slot name="append-title" />
        </div>
        <div class="text-body-1">
          <slot name="subtitle" />
        </div>
      </div>
      <v-spacer />
      <div v-if="!mobile">
        <slot name="append-right" />
      </div>
    </div>
    <div v-else class="d-flex mb-4 elevation-4">
      <div class="w-100">
        <div class="px-4 py-4 d-flex align-center">
          <h2 class="text-h6 font-weight-regular">
            {{ title }}
          </h2>
          <slot name="append-title">
            <v-spacer />
            <v-icon color="primary" @click="$refs.infoModal.open()">
              info_outline
            </v-icon>
            <ConfirmModal ref="infoModal" title="Help" cancel-text="Close" cancel-only>
              <slot name="subtitle" />
            </ConfirmModal>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmModal from './ConfirmModal.vue'

export default {
  components: { ConfirmModal },
  props: {
    title: { type: String, required: true },
    mobile: { type: Boolean, default: false }
  }
}
</script>
